
import restaurants2 from './restaurants2.json';
import jobs from './jobs.json';
import routines from './routines.json';
import body from './body.json';
import clothes from './clothes.json';
import furniture from './furniture.json';
import geography from './geography.json';
import feelings from './feelings.json';
import education from './education.json';

export const VOCABULARY_M7_U1 = [
    ...restaurants2,
    ...jobs,
    ...routines,
    ...body,
    ...clothes,
    ...furniture,
    ...geography,
    ...feelings,
    ...education,
];